// Auto-generado por @xone-web/staticweb (MPA Island mode).
// Config del proyecto baked at build time. NO EDITAR.

export const APP_CONFIG = {
    name: "Unnamed",
    title: "DashboardKPI",
    version: "1.0.1",
    tablePrefix: "gen",
    entryPoint: "MenuPrincipalWeb",
    loginCollection: "LoginWeb",
    autoLogon: false,
    apiBase: "/api/v1",
    defaultLanguage: "javascript",
} as const;
